// extracted by mini-css-extract-plugin
module.exports = {"text":"note_text__1fuZ0","btn":"note_btn__xJh6x","btnContainer":"note_btnContainer__VSVNo","btnContent":"note_btnContent__3kQh5"};